export const THREE_GET_RENDERER = 'THREE_GET_RENDERER'
export const THREE_GET_SCENE = 'THREE_GET_SCENE'
export const THREE_SAVE_SCENE = 'THREE_SAVE_SCENE'
export const THREE_SAVE_MODEL = 'THREE_SAVE_MODEL'
export const THREE_GET_CAMERA = 'THREE_GET_CAMERA'
export const THREE_RESET = 'THREE_RESET'
